enum Action {
  SET_SEARCH = 'setSearch',
  SET_SELECTION = 'setSelection',
}

export default Action;
